import { render } from "./Corp2FAToggle.vue?vue&type=template&id=8d397404&scoped=true"
import script from "./Corp2FAToggle.vue?vue&type=script&lang=js"
export * from "./Corp2FAToggle.vue?vue&type=script&lang=js"

import "./Corp2FAToggle.vue?vue&type=style&index=0&id=8d397404&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d397404"]])

export default __exports__